module.exports = __webpack_public_path__ + "static/media/014.cdbcd33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/014.jpg
// module id = 487
// module chunks = 0